"use client";

import { cn } from "@/lib/utils";

interface LogoProps {
  className?: string;
  size?: "sm" | "md" | "lg" | "xl";
  showText?: boolean;
  textClassName?: string;
}

const sizes = {
  sm: { icon: 28, text: "text-lg" },
  md: { icon: 36, text: "text-xl" },
  lg: { icon: 48, text: "text-2xl" },
  xl: { icon: 64, text: "text-3xl" },
};

export function Logo({ 
  className, 
  size = "md", 
  showText = true,
  textClassName 
}: LogoProps) {
  const { icon: iconSize, text: textSize } = sizes[size];

  return (
    <div className={cn("flex items-center gap-2.5", className)}>
      {/* Logo Icon - Dynamic dark mode support */}
      <svg 
        width={iconSize} 
        height={iconSize} 
        viewBox="0 0 48 48" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        className="shrink-0"
      >
        <rect 
          width="48" 
          height="48" 
          rx="11" 
          className="fill-[#0a0a0a] dark:fill-white"
        />
        {/* Hebrew Aleph symbol */}
        <text
          x="50%"
          y="54%"
          dominantBaseline="middle"
          textAnchor="middle"
          className="fill-white dark:fill-[#0a0a0a]"
          fontSize="32"
          fontWeight="600"
          fontFamily="system-ui, -apple-system, sans-serif"
        >
          א
        </text>
      </svg>

      {/* Logo Text */}
      {showText && (
        <span 
          className={cn(
            "font-bold tracking-tight text-foreground",
            textSize,
            textClassName
          )}
        >
          Axlynq
        </span>
      )}
    </div>
  );
}

export function LogoIcon({ className, size = 48 }: { className?: string; size?: number }) {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 48 48" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect 
        width="48" 
        height="48" 
        rx="11" 
        className="fill-[#0a0a0a] dark:fill-white"
      />
      {/* Hebrew Aleph symbol */}
      <text
        x="50%"
        y="54%"
        dominantBaseline="middle"
        textAnchor="middle"
        className="fill-white dark:fill-[#0a0a0a]"
        fontSize="32"
        fontWeight="600"
        fontFamily="system-ui, -apple-system, sans-serif"
      >
        א
      </text>
    </svg>
  );
}
